import { AdminDashboard } from '../admin-dashboard/adminDashboard';
import { FileUpload } from '../fileUpload/fileUpload';
import { UploadData } from '../upload-data/uploadData';
import { Anonymization } from '../anonymization/anonymization';
import { SectorLandingPage } from '../sectorLandingPage/sectorLandingPage';
import { OverViewPage } from '../OverviewPage';
import { AdminInsights } from '../admin-insights/AdminInsights';
import { DataLayer } from '../data-layer/dataLayer';
import { DataQuality } from '../data-quality/dataQuality';
import { Logout } from '../logout/Logout';
import {AdminSettings} from'../admin-settings/adminSettings';
import { ExternalUserRegistration } from '../ExternalUserRegistration/ExternalUserRegistration';
import { PartnerFileUpload } from '../partnerFileUpload/partnerFileUpload';
import { UserManagement } from '../UserManagement/userManagement';
import { DeploymentScheduler } from '../deployment-scheduler/deploymentScheduler';
import {UploadPartnerData} from"../partnerFileUpload/uploadPartnerData";
import {UploadPartnerEngagementData} from"../partnerFileUpload/uploadPartnerEngagementData";
import SessionExpired from '../session-expired/SessionExpired';
import { AdminLandingPage } from '../AdminFlow/adminLandingPage';
import ErrorPage from '../error/error';
import HelpPage  from '../GetHelp/HelpPage';
import FAQ from '../FAQ/faq';
import FAQViewer from '../GetHelp/FAQViewer';
import OutagePage from '../outage/outage';
import { Chatbot } from '../ui-chatbot/Chatbot';
import { PrivacyNoticePage } from '../ui-chatbot/privacyNoticePage';
 //import {WhiteGlovesHome} from"../home/WhiteGlovesHome";
// import {WhiteGlovesHome} from"../../whitegloves/components/home/WhiteGlovesHome";
// import {WhiteGlovesJourney} from"../../whitegloves/components/journey/WhiteGlovesJourney";
// import {MainComponent} from "../../whitegloves/components/requestForm/MainComponent"

export const AppNavItems = [
   
  {
    id: 10,
    title: 'Steps',
    path: '/steps',
    component: <AdminDashboard />,
  },
  {
    id: 11,
    title: 'Files',
    path: '/steps/files',
    component: <FileUpload />,
  },
  {
    id: 12,
    title: 'Upload',
    path: '/steps/files/upload',
    component: <UploadData />,
  },
  {
    id: 13,
    title: 'Anonymization',
    path: '/steps/anonymization',
    component: <Anonymization />,
  },
  {
    id: 14,
    title: 'Sectors',
    path: '/sectors',
    component: <SectorLandingPage />
  },
  {
    id: 15,
    title: 'Dashboard',
    path: '/sectors/dashboard/:sector',
    component: <OverViewPage />
  },
  {
    id: 16,
    title: 'Insights',
    path: '/steps/insights',
    component: <AdminInsights />
  }
  ,
  {
    id: 17,
    title: 'Extraction',
    path: '/steps/extraction',
    component: <DataLayer />
  }
  ,
  ,
  {
    id: 18,
    title: 'Quality',
    path: '/steps/quality',
    component: <DataQuality />
  },
  {
    id: 19,
    title: 'Log out',
    path: '/logout',
    component: <Logout />
  }
  ,
  {
    id: 20,
    title: 'Settings',
    path: '/settings',
    component: <AdminSettings />
  }
  ,
  {
    id: 23,
    title: 'Register',
    path: '/eureg',
    component: <ExternalUserRegistration />
  }
  ,
  {
    id: 24,
    title: 'UI Upload',
    path: '/uploadedFiles',
    component: <PartnerFileUpload />
  },
  {
    id: 25,
    title: 'User ',
    path: '/settings/user',
    component: <UserManagement />
  },
  {
    id: 34,
    title: 'Deployment Scheduler',
    path: '/settings/deployment-scheduler',
    component: <DeploymentScheduler />
  },
  {
    id: 26,
    title: 'Upload Data ',
    path: '/uploadFileData',
    component: <UploadPartnerData />
  },
  {
    id: 21,
    title: 'Upload Data ',
    path: '/uploadEngagementData',
    component: <UploadPartnerEngagementData />
  },
  {
    id: 27,
    title: 'Admin Page',
    path: '/adminPage',
    component: <AdminLandingPage />
  },
   {
     id: 28,
    title: 'Session Expired',
    path: '/session-expired',
    component: <SessionExpired />
  },
  {
    id: 29,
    title: 'Error Page',
    path: '/error',
    component: <ErrorPage />
  },
   {
    id: 30,
    title: 'Get Help',
    path: '/help',
    component: <HelpPage />
  },
   {
    id: 31,
    title: 'FAQ',
    path: '/faq',
    component: <FAQ />
  },
   {
    id: 32,
    title: 'FAQ Viewer',
    path: '/faq-viewer',
    component: <FAQViewer />
  },
   {
    id: 33,
    title: 'Maintenance',
    path: '/maintenance',
    component: <OutagePage />
  },
   {
    id: 35,
    title: 'DBS AI Chatbot',
    path: '/chat',
    component: <Chatbot />
  },
  {
    id: 36,
    title: 'Chat Privacy Notice',
    path: '/chat/privacy-notice',
    component: <PrivacyNoticePage />
  }/*,
  {
    id: 26,
    title: 'White Gloves',
    path: '/whitegloves',
    component: <WhiteGlovesHome />
  },
   {
    id: 26,
    title: 'White Glove Journey',
    path: '/whitegloves/journey',
    component: <WhiteGlovesJourney />
  },
  {
    id: 26,
    title: 'Request Form ',
    path: '/whitegloves/requestform',
    component: <MainComponent />
  }*/
];
